"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"app":"app_TgHI7"};
tokens._getCss = function () {return `/* imported from app.css */ body { margin: 0; padding: 0; max-width: 100vw; overflow-x: hidden; } * { -webkit-box-sizing: border-box; box-sizing: border-box; } .app_TgHI7 { font-size: 14px; color: rgba(0,0,0,0.87); display: block; position: relative; overflow-x: hidden; } div.app_TgHI7 > * { font-family: "Helvetica Neue", Helvetica, Arial, sans-serif; } @media (orientation: portrait) { .app_TgHI7 { max-width: 100vh; } } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/template/app_css.js"};
exports["default"] = tokens;